'use client';

import React from 'react';
import PrivacyPolicy from '@/components/organisms/privacy-policy';

const PrivacyPolicyTastic = ({data}: any) => {
    const privacyPolicyData = data.data.dataSource;
    
    return <PrivacyPolicy isPrivacy={true} privacyPolicyData={privacyPolicyData} />
};

export default PrivacyPolicyTastic;